const GOOGLE_FONTS_HOST = "fonts.googleapis.com";

/**
 * Parses a Google Fonts stylesheet URL into a normalized link and CSS family name.
 * @example `https://fonts.googleapis.com/css2?family=Roboto:wght@400&display=swap` → `{ family: "Roboto", ... }`
 */
export const parseGoogleFontsStylesheetUrl = (
  rawUrl: string,
): { stylesheetUrl: string; family: string } | null => {
  const trimmed = rawUrl.trim();
  if (trimmed.length === 0) return null;

  try {
    const url = new URL(trimmed);
    if (url.protocol !== "https:" || url.hostname !== GOOGLE_FONTS_HOST) {
      return null;
    }

    const familyParam = url.searchParams.get("family");
    if (familyParam === null || familyParam.length === 0) return null;

    const firstFamilyToken = familyParam.split("|")[0]?.split(":")[0];
    if (firstFamilyToken === undefined || firstFamilyToken.length === 0) {
      return null;
    }

    const family = decodeURIComponent(firstFamilyToken.replace(/\+/g, " "));
    return { stylesheetUrl: url.toString(), family };
  } catch {
    return null;
  }
};
